import MySavedWholesaleSuppliers from "./MySavedWholesaleSuppliers/index.tsx";
import NewestWholesaleSuppliers from "./NewestWholesaleSuppliers/index.tsx";
import SearchWholesaleSuppliers from "./SearchWholesaleSuppliers/index.tsx";

export default {
  SearchWholesaleSuppliers,
  NewestWholesaleSuppliers,
  MySavedWholesaleSuppliers
};

export {
  SearchWholesaleSuppliers,
  NewestWholesaleSuppliers,
  MySavedWholesaleSuppliers,
};
